module.exports = __webpack_public_path__ + "img/icon_default_man.33e12287.png";